module.exports = __webpack_public_path__ + "files/a5085a76f5c6985395cc87fde9ac9bcb.png";